import React from "react";
import { useSelector } from "react-redux";

const ScormBigIcon = ({ fill }) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52.968"
      height="43.114"
      viewBox="0 0 52.968 43.114"
    >
      <g id="db38" transform="translate(-172.366 -210.25)">
        <path
          id="Path_1274"
          data-name="Path 1274"
          d="M274.384,315.055v2.463a.616.616,0,0,1-.616.616H239.277a.616.616,0,0,1-.616-.616v-2.463a.616.616,0,0,1,.616-.616h34.491A.615.615,0,0,1,274.384,315.055Z"
          transform="translate(-57.673 -90.639)"
          fill={fill ? fill : colors.theme}
        />
        <path
          id="Path_1275"
          data-name="Path 1275"
          d="M255.291,371.881V384.2a.616.616,0,0,1-.616.616h-15.4a.616.616,0,0,1-.616-.616V371.881a.616.616,0,0,1,.616-.616h15.4a.616.616,0,0,1,.616.616Z"
          transform="translate(-57.673 -140.075)"
          fill={fill ? fill : colors.theme}
        />
        <path
          id="Path_1276"
          data-name="Path 1276"
          d="M402.1,371.881V384.2a.616.616,0,0,1-.616.616h-15.4a.616.616,0,0,1-.616-.616V371.881a.616.616,0,0,1,.616-.616h15.4a.616.616,0,0,1,.616.616Z"
          transform="translate(-185.39 -140.075)"
          fill={fill ? fill : colors.theme}
        />
        <path
          id="Path_1277"
          data-name="Path 1277"
          d="M221.638,210.25H176.061a3.7,3.7,0,0,0-3.7,3.7v35.723a3.7,3.7,0,0,0,3.7,3.7h45.577a3.7,3.7,0,0,0,3.7-3.7V213.945A3.7,3.7,0,0,0,221.638,210.25Zm-4.311,2.463a1.848,1.848,0,1,1-1.848,1.848A1.847,1.847,0,0,1,217.327,212.713Zm-7.391,0a1.848,1.848,0,1,1-1.848,1.848A1.847,1.847,0,0,1,209.936,212.713Zm-7.391,0a1.848,1.848,0,1,1-1.848,1.848A1.847,1.847,0,0,1,202.546,212.713Zm19.093,36.338a.616.616,0,0,1-.616.616H176.677a.616.616,0,0,1-.616-.616V219.488a.616.616,0,0,1,.616-.616h44.346a.616.616,0,0,1,.616.616Z"
          transform="translate(0 0)"
          fill={fill ? fill : colors.theme}
        />
      </g>
    </svg>
  );
};

export default ScormBigIcon;
